import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './Sidemenu.scss'
import { Link } from 'react-router-dom'
import closeIcon from '../../assets/images/closeIcon.svg'


class Sidemenu extends React.Component {

    componentDidMount() {
        document.getElementById("HamburgerID").addEventListener("click", function(){
            document.getElementById("sidemenuID").style.top = '0'
        });

        document.getElementById("sidemenuID").addEventListener("click", function(){
            document.getElementById("sidemenuID").style.top = '-100%'
        });
    }

    
    render() {
        
        return (
            <div className="sidemenu" id="sidemenuID">
                <img src={closeIcon} alt="close" />
                <div className="listContainer">
                    <ul>
                        <Link to={this.props.path1} style={{textDecoration: 'none', color: '#fff'}}><li>{this.props.name1}</li></Link>
                        {/* <Link to="/chi-siamo" style={{textDecoration: 'none', color: '#fff'}}><li>Chi Siamo</li></Link> */}
                        <Link to={this.props.path2} style={{textDecoration: 'none', color: '#fff'}}><li>{this.props.name2}</li></Link>
                        <Link to={this.props.path3} style={{textDecoration: 'none', color: '#fff'}}><li>{this.props.name3}</li></Link>
                        <Link to={this.props.path4} style={{textDecoration: 'none', color: '#fff'}}><li>{this.props.name4}</li></Link>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Sidemenu
